import {
  SetUploadImagePayload,
  ImageActions,
  UploadImageStateProps,
} from './props';

export function setUploadImage(
  uploadImage: UploadImageStateProps,
): SetUploadImagePayload {
  return {
    type: ImageActions.UploadImage,
    payload: {
      ...uploadImage,
      id: uploadImage.id?.toString(),
    },
  };
}
